import theme from '@ifca-root/react-component/src/assets/theme';
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import {
	DraggableItem,
	DragNDropList,
	DropableItem,
} from '@ifca-root/react-component/src/components/CardList/DragAndDropList';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { MsgAlert } from '@ifca-root/react-component/src/components/others/MsgAlert';
import { Button, Grid, useMediaQuery } from '@material-ui/core';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	useDragTableMutation,
	useGetOutletQuery,
	useGetTableQuery,
} from 'generated/graphql';
import { SystemMsgs } from 'helpers/SystemMsg';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ExcelIcon from '../../../../assets/icons/excel.svg';
import ShareIcon from '@material-ui/icons/Share';
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelInput';
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_CURRENCY } from 'containers/AccountModule/AccountQuery';
import { AccountClient } from 'ProductsClient';

export const TableList = () => {
	const { outletID } = useParams<any>();
	const history = useHistory();

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	// const { setOpenSnackBar, setSnackBarMsg } = useContext(
	// 	SnackBarContext as any,
	// );

	const [openDialog, setOpenDialog] = useState(false);
	const {
		openFileUpload,
		setOpenFileUpload,
		fileTitle,
		setFileTitle,
		openSnackBar,
		setOpenSnackBar,
		snackBarMessage,
		currentData,
		setCurrentData,
		onDownloadTemplate,
		onSelectFile,
		duplicateItems,
		errorDialog:duplicateErrorDia,
		setErrorDialog,
		resetFileUpload,
		setSnackBarMessage
	}=useExcelUploadVersion2();
	const {
		called: ouletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});
	const [
		loadCurrency,
		{
			loading: currencyLoading,
			error: currencyError,
			data: { getCurrency } = { getCurrency: [] },
		},
	] = useLazyQuery(GET_CURRENCY, {
		client: AccountClient,
	});

	const outletArray: any[] = getOutlet;

	const {
		data: { getTable } = { getTable: [] },
		loading: tableLoading,
	} = useGetTableQuery({
		fetchPolicy: 'network-only',
		variables: { outletID: outletID, orderByAsc: 'sequence', isActive: true },
	});

	const [
		dragTable,
		{ loading: dragTableLoading, error: dragTableError },
	] = useDragTableMutation({
		onError: error => {
			console.log('ERROR', error);
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMessage(SystemMsgs.updateRecord());
			setOpenDialog(false);
		},
	});

	let [initialData, setInitialData] = useState<any>();

	useEffect(() => {
		setInitialData(getTable);
	}, [getTable?.length]);

	const onDragEnd = ({ source, destination }) => {
		if (destination === undefined || destination === null) return null;

		if (
			source.droppableId === destination.droppableId &&
			destination.index === source.index
		)
			return null;

		const start = source.droppableId;
		const end = destination.droppableId;

		if (start === end) {
			let testArray = initialData.filter((_, idx) => idx !== source.index);

			testArray.splice(destination.index, 0, initialData[source.index]);

			setInitialData([...testArray]);

			dragTable({
				variables: {
					input: testArray?.map((el, index) => {
						return {
							ID: el?.ID,
							prefix: el?.prefix,
							tableNumber: el?.tableNumber,
							seatCount: el?.seatCount,
							sequence: index + 1,
							outletID: outletID,
						};
					}),
				},
			});

			return null;
		}
	};

	return (
		<>
			{outletLoading && <Loading />}
			{tableLoading && <Loading />}

			<MainHeader
				onClick={() =>
					history.push({
						pathname: `/menu/outlet-app/outlet-setting/${outletID}`,
					})
				}
				mainBtn="back"
				smTitle={`Outlet App`}
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Outlet Settings' },
					{ name: 'Table', current: true },
				]}
			/>

			<ContentWrapper
				tableHeader
				style={{
					marginTop: isDesktop ? '84px' : '-3px',
					padding: '8px 8px 0px',
					top: isDesktop ? '65px' : '65px',
				}}
			>
				<MsgAlert message={'Drag & drop to arrange sequence. '} />
			<div className="message-alert text-noflow">
				<div className="flex-space">
					<div className="icon-text">
						<img
							src={ExcelIcon}
							style={{ width: '19px', paddingRight: '5px' }}
						/>
						<span className='mdDesc'>
							<span style={{fontWeight:'bold'}}>Download</span>{' '}
							<span>Excel Template</span>
						</span>
					</div>
				</div>
				<div>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						style={{
						minWidth: '0px',
						width: '32px',
						height: '24px',
						margin: '-2px 0px -2px 0px',
						}}
						onClick={() => {
						setOpenDialog(true)
						}}
					>
						<ShareIcon
						style={{
							width: '17px',
							height: '17px',
						}}
						/>
					</Button>
            </div>
          </div>
				<CardContents>
					<Grid container>
						<Grid xs={3} className="left">
							<div className="content-wrap full">
								<div style={{ padding: '3px' }} className="xsTitle">
									Prefix
								</div>
							</div>
						</Grid>
						<Grid xs={3} className="left">
							<div className="content-wrap full">
								<div
									style={{ padding: '3px', textAlign: 'right' }}
									className="xsTitle"
								>
									Table No.
								</div>
							</div>
						</Grid>
						<Grid xs={6} className="left">
							<div className="content-wrap full">
								<div
									style={{ padding: '3px', textAlign: 'right' }}
									className="xsTitle"
								>
									Max Seating
								</div>
							</div>
						</Grid>
					</Grid>
				</CardContents>
			</ContentWrapper>

			<ContentWrapper float style={{ marginTop: isDesktop ? '170px' : '67px' }}>
				{!tableLoading &&
				!outletLoading &&
				(getTable === undefined || getTable?.length === 0) ? (
					<EmptyList
						title="No Record found"
						subtitle="Please add table to continue"
					/>
				) : (
					<div className="table-form">
						<CardContents devFullWidth={true}>
							<DragNDropList onDragEnd={onDragEnd}>
								<DropableItem droppableId={'table_list'}>
									{initialData?.map((el, index) => {
										return (
											<>
												<div className="table-list">
													<DraggableItem
														id={el?.ID}
														index={index}
														draggableId={el?.ID}
													>
														<Grid container>
															<Grid item xs={3} className="left">
																<div className="content-wrap full">
																	<div className="xsTitle">{el?.prefix}</div>
																</div>
															</Grid>
															<Grid item xs={3} className="left">
																<div className="content-wrap full">
																	<div
																		className="xsTitle"
																		style={{
																			padding: '3px',
																			textAlign: 'right',
																		}}
																	>
																		<span
																			className="xxTitle fw-medium"
																			style={{ color: '#ff9800' }}
																		>
																			{el?.tableNumber}
																		</span>
																	</div>
																</div>
															</Grid>
															<Grid item xs={6} className="right">
																<div className="content-wrap full">
																	<div
																		className="xsTitle"
																		style={{
																			padding: '3px',
																			textAlign: 'right',
																		}}
																	>
																		<span
																			className="xxTitle fw-medium"
																			style={{ color: '#ff9800' }}
																		>
																			{el?.seatCount}
																		</span>
																	</div>
																</div>
															</Grid>
														</Grid>
													</DraggableItem>
												</div>
											</>
										);
									})}
								</DropableItem>
							</DragNDropList>
						</CardContents>
					</div>
				)}
			</ContentWrapper>

			<ExcelInput
				showFooter={false}
				showDupErrors={true}
				duplicateItems={duplicateItems}
				errorDia={duplicateErrorDia}
				setErrorDia={setErrorDialog}
				openUpload={openDialog}
				setOpenUpload={setOpenDialog}
				upload={fileTitle}
				template={currentData}
				setTemplate={setCurrentData}
				setUpload={setFileTitle}
				resetFileUpload={resetFileUpload}
				onUploadTemplate={() => {
				const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
				const exceldata = [
					{
						table:[],
						testing:[]
					}
				];
				const sheetvalidation = (sheetName,targetkey,mapping)=>{
						const sheet = currentData.find(
							s=>normalize(s.sheetName)=== normalize(sheetName)
						);

						if (!sheet) {
							console.warn(`Sheet ${sheetName} not found`);
							return ;
						}
						
						exceldata[0][targetkey].push({
							sheetName:sheetName,
							rows:sheet.rows.map(mapping),
						})
					}
				// const menuSheet = currentData.find(
				// 	s =>normalize(s.sheetName) === normalize("MenuItemList")
				// );
				// if (!menuSheet) {
				// 	console.error("MenuItemList sheet not found:", currentData);
				// 	return;
				// }

				console.log('currentData',currentData);
				

				// const digitalmenuSheet = currentData.find(
				// 	s => s.sheetName?.trim().toLowerCase() === "digitalmenu"
				// );
				// console.log('currentdata',currentData);
				
				// if (!digitalmenuSheet) {
				// 	console.error("DigitalMenu sheet not found:", currentData);
				// 	return;
				// }
				// const Testingsheet = currentData.find(
				// 	s =>normalize( s.sheetName) === normalize("testing")
				// );

				// if (!Testingsheet) {
				// 	console.error("Testing sheet not found:", Testingsheet);
				// 	return;
				// }

				sheetvalidation("Table","table",x=>({
					sheetName:"Table",

					prefix: x?.prefix === null ? null:`${x?.prefix}`,
					tableNumber: x?.tableNumber === null ? null:`${x?.tableNumber}`,
					seatCount:Number(x?.seatCount) === null? null:Number(x?.seatCount),
					
				}));
				
				sheetvalidation("Testing","testing",x=>({
					sheetName:"Testing",
					testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
					testingemail: x?.testingemail=== null? null:`${x?.testingemail?.trim()}`,
				}));

				console.log("exceldata",exceldata);
				
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/table/excel-validation`,
					state: {
						excelData:exceldata,
						//  [
							// {
								// sheetName: "MenuItemList",
								// rows: menuSheet?.rows?.map(x => ({
								// 	name: x?.name?.trim() || null,
								// 	nativeName: x?.nativeName?.trim() || null,
								// 	kitchenName: x?.kitchenName?.trim() || null,
								// 	description: x?.description?.trim() || null,
								// 	major: x?.major?.trim() || null,
								// 	family: x?.family?.trim() || null,
								// 	kitchenPrinter: x?.kitchenPrinter?.trim() || null,
								// 	taxschemes: x?.taxschemes?.trim() || null,
								// 	uom: x?.uom?.trim() || null,
								// 	defaultQuantity: Number(x?.defaultQuantity) || 0,
								// 	isOpenItem: String(x?.isOpenItem).trim(),
								// 	isOpenPrice: String(x?.isOpenPrice).trim(),
								// 	isChefRecommended: String(x?.isChefRecommended).trim(),
								// 	isQuantityControlled: String(x?.isQuantityControlled).trim(),
								// 	isDiscountable: String(x?.isDiscountable).trim(),
								// 	isByWeight: String(x?.isByWeight).trim(),
								// 	standardCost: Number(x?.standardCost) || 0,
								// 	isPerforated: String(x?.isPerforated).trim(),
								// 	perforatedQuantity:
								// 		x?.perforatedQuantity == null
								// 			? null
								// 			: Number(x?.perforatedQuantity)
								// }))
								// sheetvalidation("MenuItemList",x=>({
								// 	name: x?.name?.trim() || null,
								// 	nativeName: x?.nativeName?.trim() || null,
								// 	kitchenName: x?.kitchenName?.trim() || null,
								// 	description: x?.description?.trim() || null,
								// 	major: x?.major?.trim() || null,
								// 	family: x?.family?.trim() || null,
								// 	kitchenPrinter: x?.kitchenPrinter?.trim() || null,
								// 	taxschemes: x?.taxschemes?.trim() || null,
								// 	uom: x?.uom?.trim() || null,
								// 	defaultQuantity: Number(x?.defaultQuantity) || 0,
								// 	isOpenItem: String(x?.isOpenItem).trim(),
								// 	isOpenPrice: String(x?.isOpenPrice).trim(),
								// 	isChefRecommended: String(x?.isChefRecommended).trim(),
								// 	isQuantityControlled: String(x?.isQuantityControlled).trim(),
								// 	isDiscountable: String(x?.isDiscountable).trim(),
								// 	isByWeight: String(x?.isByWeight).trim(),
								// 	standardCost: Number(x?.standardCost) || 0,
								// 	isPerforated: String(x?.isPerforated).trim(),
								// 	perforatedQuantity:
								// 		x?.perforatedQuantity == null
								// 			? null
								// 			: Number(x?.perforatedQuantity)
								// })),
								
								// sheetvalidation("Testing",x=>({
								// 	testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
								// 	testingemail: x?.testingemail=== null?null:`${x?.testingemail?.trim()}`,
								// }))
							// },
							// {
							// 	sheetName: "DigitalMenu",
							// 	rows: digitalmenuSheet.rows?.map(x => ({
							// 		outletName: x?.outletName?.trim() || null,
							// 		Name: x?.Name?.trim() || null,
							// 		Description: x?.Description?.trim() || null
							// 	}))
							// },
							// {
							// 	sheetName: "Testing",
							// 	rows: Testingsheet.rows?.map(x => ({
							// 		testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
							// 		testingemail: x?.testingemail=== null?null:`${x?.testingemail?.trim()}`,
							// 	}))
							// },
						// ]
						
						fileTitle
					}
				});

				setOpenFileUpload(false);
				}}

				onSelectFile={(e: any) => {
				onSelectFile({ event: e})
				}}
				downloadButton={true}
				onDownloadTemplate={() => {
				onDownloadTemplate({
					name: `Table`,
					// workSheetName: `MenuItemList123`,
					sheet:[
					{
						sheetName:"Table",
						headerSetup:tableForm,
					},
					],
					// headerSetup: extJournalTemplateForm,
					isHeaderLocked: true,
					defaultHeaderFillStyle: {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'D3D3D3' },
					},
					defaultHeaderBorderStyle: {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' },
					},
					listType: {
					hasCountry: true,
					hasNationality: true,
					},
					extraListData: [
					{
						data: getCurrency?.map(x => x?.code),
						worksheetName: 'BaseCurrency',
						dataType: 'BaseCurrency',
					},
					{
						data: [
						'No Tax',
						'GST Registration No.',
						'SST Registration No.',
						],
						worksheetName: 'companytax',
						dataType: 'companytax',
					},
					],
				})
				}}
				snackBarProps={{
				openSnackBar: openSnackBar,
				snackBarMessage: snackBarMessage,
				setOpenSnackBar: setOpenSnackBar,
				onClickButton: () => {
					setOpenSnackBar(false)
				},
				}}
			/>
			<FloatButton
				isCreate={true}
				onClick={() =>
					history.push(`/menu/outlet-app/outlet-setting/${outletID}/table/add`)
				}
			/>
		</>
	);
};
export const tableForm =[
  {
    header: {
      header: 'prefix',
      width: 17,
    },
  },
   {
    header: {
      header: 'tableNumber',
      width: 17,
    },
  },
  {
    header: {
      header: 'seatCount',
      width: 17,
    },
  },
];